module.exports = __webpack_public_path__ + "static/footerLogo-fd459d44894bccfc82419743d280f8b0.png";